export function CameraResetSvg() {
  return (
    <svg version="1.0" viewBox="0 0 246 246">
      <g className="svg-icon">
        <path
          d="M1055 2420c-87-14-227-56-318-95-85-37-256-146-296-189-14-14-29-26-34-26s-8 43-6 101c4 88 2 103-13 113-36 22-46-9-57-174-8-124-8-157 3-168 10-10 46-11 171-5 131 7 160 11 168 25 8 12 7 21-3 33-12 15-30 17-117 13l-103-3 33 33c38 39 168 128 247 167 188 95 450 136 661 105 492-71 888-467 959-959 19-127 8-323-25-446-104-394-415-705-812-812-89-25-114-27-283-27s-194 2-283 27C481 259 134 672 103 1138l-6 92H30v-53c0-131 50-328 120-472C292 411 581 166 890 77c213-61 467-61 680 0 176 50 373 169 509 304 343 345 443 845 260 1309-111 279-370 538-649 649-156 61-258 82-425 86-82 2-177 0-210-5z"
          transform="matrix(.1 0 0 -.1 0 246)"
        />
        <path
          d="M993 1959c-39-11-48-27-83-139l-27-85-174-5c-190-5-219-14-239-66-6-15-10-211-10-469V750l29-32 29-33h1424l29 33 30 33-3 459-3 460-28 27-27 28-181 5-181 5-27 85c-37 115-45 127-89 140-46 12-425 12-469-1zm375-411c75-28 161-111 198-190 25-55 29-75 29-153 0-118-31-191-116-269-76-71-147-99-249-99-145 0-266 77-332 211-30 60-33 75-33 157 0 77 4 98 27 147 87 186 284 267 476 196zm460 20c34-34-3-68-73-68-44 0-57 4-69 22-11 15-12 26-5 40 8 14 22 18 72 18 36 0 68-5 75-12z"
          transform="matrix(.1 0 0 -.1 0 246)"
        />
        <path
          d="M1135 1478c-160-58-240-251-165-398 55-107 141-160 259-160 119 1 205 52 259 154 22 43 27 64 27 131 0 70-4 87-30 134-36 65-92 115-153 135-52 18-152 20-197 4zm155-68c19-5 52-24 73-41 103-85 105-238 3-327-135-118-346-19-346 163 0 144 132 244 270 205z"
          transform="matrix(.1 0 0 -.1 0 246)"
        />
        <path
          d="M1195 1333c-123-33-128-211-7-253 37-13 47-13 84 0 99 35 120 177 35 233-27 18-83 28-112 20z"
          transform="matrix(.1 0 0 -.1 0 246)"
        />
      </g>
    </svg>
  );
}
